import { Container} from '@mui/material';
import TradeDataMainSearch from "src/features/TradeDataMainSearch";

const Home = () => {
  return (
    <Container maxWidth="xl" sx={{ textAlign: 'center', py: 5, position: 'relative' }}>
      <TradeDataMainSearch/>
    </Container>
  );
};

export default Home;
